module.exports = __webpack_public_path__ + "media/warranty-claim/vent-120589b2.svg";